import { Stack } from '@mui/material';
import { colors } from 'src/theme/palette/darkPalette';
import Iconify from '../Iconify';

const FilterCount = ({ filteredCount, onOpenFilters, onlyView = false, sx = {} }) => {
  const hasFilter = typeof filteredCount === 'number';

  const label = hasFilter ? `Filtered (${filteredCount})` : 'Filter';

  const filterColor = hasFilter ? colors.green : colors.white;

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      color={filterColor}
      sx={{
        cursor: onlyView ? 'unset' : 'pointer',
        backgroundColor: '#4B4B4B',
        width: 'fit-content',
        minHeight: '24px',
        ml: 'auto',
        p: '0 8px',
        minWidth: '80px',
        borderRadius: 1,
        fontSize: '14px',
        position: 'absolute',
        top: '-28px',
        right: 0,
        fontWeight: 600,
        ...sx,
      }}
      onClick={onlyView ? undefined : onOpenFilters}
      gap={1}>
      {label}
      <Iconify
        icon="octicon:filter-16"
        color={filterColor}
        width={16}
        height={16}
        sx={{
          cursor: onlyView ? 'unset' : 'pointer',
        }}
        onClick={onlyView ? undefined : onOpenFilters}
      />
    </Stack>
  );
};

export default FilterCount;
